import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/app/Navbar";
import { Home, Search } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col font-sans">
      <Navbar />
      <main className="flex-1 flex flex-col items-center justify-center text-center p-6">
        <h1 className="font-serif text-6xl font-bold text-[#2A4B3C] mb-4">404</h1>
        <h2 className="text-2xl font-bold text-stone-800 mb-2">Page Not Found</h2>
        <p className="text-stone-600 max-w-md mb-8">
          The page you are looking for doesn't exist or has been moved. Let's get you back on track to find your next home.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#2A4B3C] text-white font-medium hover:bg-[#1E362B] transition-colors"
          >
            <Home className="w-4 h-4" />
            Go to Home
          </Link>
          <Link
            to="/browse"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-stone-300 text-stone-700 font-medium hover:bg-stone-50 transition-colors"
          >
            <Search className="w-4 h-4" />
            Browse Listings
          </Link>
        </div>
      </main>
    </div>
  );
}
